export function getGenerateMatchesErrorMessage(error: unknown): string {
  const msg = String(error);

  if (msg.includes('Not allowed')) {
    return 'У вас нет прав для генерации матчей';
  }
  if (msg.includes('Unsupported stage type')) {
    return 'Автогенерация недоступна для данного типа этапа. Поддерживаются: круговой и групповой форматы';
  }
  if (msg.includes('has no team groups')) {
    return 'На этапе нет групп команд. Добавьте группы перед генерацией матчей';
  }
  if (msg.includes('Not enough teams') && msg.includes('Group')) {
    return 'В одной из групп меньше 2 команд. Добавьте команды во все группы';
  }
  if (msg.includes('Not enough teams')) {
    return 'Недостаточно команд на этапе. Добавьте минимум 2 команды';
  }

  return 'Ошибка генерации матчей';
}
